module.exports = __webpack_public_path__ + "img/Mantraz-logo.f77e55e4.svg";